/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */
export const setClassNames = (...classes) => {
	const classList = new Set(classes);
	return [...classList].filter((c) => c).join(' ') || null;
};

/**
 * Determines the dialog related class that needs to be set
 * @param {bool} isClickableModal - Should the element trigger a modal
 * @param {string} deviceType - The request data device ('MOBILE', 'DESKTOP')
 */
export const setDialogClasses = (isClickableModal, deviceType) => {
	let dialogClass = null;
	if (isClickableModal) {
		dialogClass = 'dialog';
	} else if (deviceType === 'MOBILE') {
		dialogClass = 'slidein-disabled';
	}

	return dialogClass;
};
